export default __webpack_public_path__ + "static/media/Vedlegg 1 – Tilsagn om tilskudd.a3ec2ec5.pdf";